import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloFluxBuilder extends AloBase {    
    newId:number
    bldClassGen:string
    bldDisabled:boolean
    bldIsPublic:boolean
    bldKey:string
    bldJsonParam:string
}

export const getDefaultAloFluxBuilder = ():AloFluxBuilder => {
    return {
        ...getDefaultAloBase(),
        newId:0,
        bldClassGen:'',
        bldDisabled:false,
        bldIsPublic:false,
        bldKey:'undefined',
        bldJsonParam:'{}'
    }
}

export const cleanAloFluxBuilder = (fluxBuilder:AloFluxBuilder) => {
    if(!fluxBuilder) return    
    if(!fluxBuilder.id) delete fluxBuilder.id
}
